import { toWords } from 'number-to-words';

const formatCurrencyWords = (amount, currencyCode) => {
  const wholePart = Math.floor(amount);
  const decimalPart = Math.round((amount - wholePart) * 100);

  const wholePartWords = toWords(wholePart);
  const capitalizedWholePart = wholePartWords.charAt(0).toUpperCase() + wholePartWords.slice(1);

  if (decimalPart === 0) {
    return `${currencyCode} ${capitalizedWholePart}`;
  }

  const decimalPartWords = toWords(decimalPart);
  const capitalizedDecimalPart = decimalPartWords.charAt(0).toUpperCase() + decimalPartWords.slice(1);

  return `${currencyCode} ${capitalizedWholePart} and ${capitalizedDecimalPart}`;
};

export default formatCurrencyWords;
